import { render, staticRenderFns } from "./SamlLogin.vue?vue&type=template&id=e6c0131e"
import script from "./SamlLogin.vue?vue&type=script&lang=js"
export * from "./SamlLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports